module.exports = __webpack_public_path__ + "static/treder-254c0df01bfe355bd0688c48afb69616.png";